import {
  CameraList,
  CameraListResponse,
  RdConnectInstance,
  RdConnectInstanceIncludeOption,
  RdConnectInstanceListParams,
  RdConnectInstancePagedListResponse,
  RdConnectInstanceResponse,
  RdConnectInstanceUpdateRequest,
  StringResponse,
} from '@apiContract';

import { receivedDigitalApi } from './index';

type TakeControlParams = {
  rdConnectInstanceId?: number;
};

type CameraListParams = {
  rdConnectInstanceId?: number;
};

const DEFAULT_INCLUDE: RdConnectInstanceIncludeOption[] = [
  RdConnectInstanceIncludeOption.ConnectedUser,
  RdConnectInstanceIncludeOption.CreatedBy,
];

export const connectInstanceApi = receivedDigitalApi.injectEndpoints({
  endpoints: (builder) => ({
    getInstances: builder.query<RdConnectInstance[], RdConnectInstanceListParams | void>({
      query: (params) => ({
        url: 'RdConnectInstance',
        params: {
          Include: DEFAULT_INCLUDE,
          ...params,
        },
      }),
      providesTags: ['ConnectInstance'],
      transformResponse: (response: RdConnectInstancePagedListResponse): RdConnectInstance[] =>
        response.objectData.items ?? [],
    }),
    takeControl: builder.mutation<StringResponse, TakeControlParams>({
      query: (requestData) => ({
        url: `RdConnectInstance/take/${requestData.rdConnectInstanceId}`,
        method: 'GET',
      }),
      invalidatesTags: ['ConnectInstance'],
    }),
    createInstallation: builder.mutation<string, { name: string }>({
      query: ({ name }) => ({
        url: `RdConnectInstance/create-activation/${encodeURIComponent(name)}`,
        method: 'POST',
      }),
      transformResponse: (response: StringResponse): string => response.objectData,
      invalidatesTags: ['ConnectInstance'],
    }),
    updateInstallation: builder.mutation<RdConnectInstance, { id: number } & RdConnectInstanceUpdateRequest>({
      query: ({ id, ...body }) => ({
        url: `RdConnectInstance/${id}`,
        method: 'PUT',
        body,
      }),
      transformResponse: (response: RdConnectInstanceResponse): RdConnectInstance => response.objectData,
      invalidatesTags: ['ConnectInstance'],
    }),
    getCamerasList: builder.query<CameraList, CameraListParams>({
      query: ({ rdConnectInstanceId, ...params }) => ({
        url: `RdConnectOperations/camera-list/${rdConnectInstanceId}`,
        params,
      }),
      transformResponse: (response: CameraListResponse): CameraList => response.objectData,
    }),
    deleteInstallation: builder.mutation<void, number>({
      query: (id) => ({
        url: `RdConnectInstance/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['ConnectInstance'],
    }),
  }),
});

export const {
  useGetInstancesQuery,
  useTakeControlMutation,
  useGetCamerasListQuery,
  useCreateInstallationMutation,
  useUpdateInstallationMutation,
  useDeleteInstallationMutation,
} = connectInstanceApi;
